import cn from "classnames";

import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import styles from "./ClientCard.module.scss";

const ClientCard = ({
  clientsData,
  taxData,
}: {
  clientsData: any;
  taxData: any;
  currentDate: string;
}) => {
  return (
    <div className={styles.root}>
      <Typography variant="bodyL" weight="semiBold" className={styles.title}>
        Steuerbetrachtung vor Erwerb
      </Typography>
      <div className={styles.inner}>
        <div className={styles.column}>
          {clientsData.map((client: any, index: number) => (
            <div key={index}>
              <Typography
                variant="bodyM"
                weight="semiBold"
                className={styles.title}
              >
                Person {index + 1}
              </Typography>

              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Veranlagung nach
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {client.taxableIncomeTitle}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  zu verst. Einkommen
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(client.taxableIncome)}
                </Typography>
              </div>
            </div>
          ))}
        </div>
        <div className={cn(styles.column, styles.rightColumn)}>
          <div className={styles.row}>
            <Typography variant="bodyM" weight="semiBold">
              Einkommenssteuer
            </Typography>
            <Typography
              variant="bodyM"
              weight="regular"
              className={styles.value}
            >
              {convertValueToLocale(taxData.incomeTax)}
            </Typography>
          </div>
          <div className={styles.row}>
            <Typography variant="bodyM" weight="semiBold">
              Solidaritätszuschlag
            </Typography>
            <Typography
              variant="bodyM"
              weight="regular"
              className={styles.value}
            >
              {convertValueToLocale(taxData.solidaritySurcharge)}
            </Typography>
          </div>
          <div className={styles.row}>
            <Typography variant="bodyM" weight="semiBold">
              Gesamtsteuerschuld
            </Typography>
            <Typography
              variant="bodyM"
              weight="regular"
              className={styles.value}
            >
              {convertValueToLocale(taxData.totalTax)}
            </Typography>
          </div>
        </div>
      </div>
      <Typography variant="bodyM" weight="regular" className={styles.date}>
        Diese Auswertung erfolgt auf Basis des aktuell geltenden
        Einkommensteuertarifs gemäß § 32a EStG (Stand: 02.12.2024)
      </Typography>
    </div>
  );
};

export default ClientCard;
